import React, { useMemo } from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import Button from '@components/shared/Button';
import CheckoutQuantitySelector from '@components/shared/CheckoutQuantitySelector';
import PurchaseOptions from '@components/shared/PurchaseOptions';
import { ProductCode, ProductCodeKey } from '@contracts';
import { useCountry } from '@hooks/useCountry';
import { isPadsStackBox } from '@utils/pads';
import useNavigate from '@utils/useNavigate';
import { useShoppingContext } from './ProductShoppingContext';

const ProductPaymentButton: React.FC = () => {
  const { t } = useTranslation();
  const { navigateWrapper } = useNavigate();
  const { country } = useCountry();
  const {
    price,
    prices,
    subscriptions,
    productHeaderData,
    boxState,
    padsBoxState,
    padsBoxStackState,
    layout,
    paymentOptionsHeader,
    productId,
    showQuantity
  } = useShoppingContext();

  const { productCode, textColor, buttonType, learnMoreLink } = productHeaderData;
  const scroll = () => {
    const section = document.querySelector('#gift-card-form');
    section?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const boxStateForProduct = useMemo(() => {
    const isPads = productCode === ProductCode.Pads;

    if (isPads) {
      return isPadsStackBox(country) ? padsBoxStackState : padsBoxState;
    }

    return boxState;
  }, [productCode, country, padsBoxStackState, padsBoxState, boxState]);

  switch (buttonType) {
    case 'multimonth':
      return (
        <PurchaseOptions
          productCode={productCode as ProductCodeKey}
          subscriptions={subscriptions}
          price={price}
          color={textColor}
          prices={prices}
          boxState={boxStateForProduct}
          layout={layout}
          paymentOptionsHeader={paymentOptionsHeader}
        />
      );
    case 'quantity selector':
      return (
        <CheckoutQuantitySelector
          id={productId}
          productCode={productCode as ProductCodeKey}
          price={price}
          showQuantity={showQuantity}
          prices={prices}
          boxState={boxStateForProduct}
        />
      );
    case 'scroll to':
      return <Button onClick={() => scroll()}>{t('components.choose-your-card')}</Button>;
    case 'learn more': {
      return learnMoreLink?.text && <Button onClick={() => navigateWrapper(learnMoreLink.text)}>{t('components.discover-cbd-tampons')}</Button>;
    }
    default:
      return <CheckoutQuantitySelector id={productId} productCode={productCode as ProductCodeKey} price={price} showQuantity={showQuantity} />;
  }
};

export default ProductPaymentButton;
